import { WITH_LOADING } from '@/store/action-types'
const START = 'START'
const END = 'END'
const state = function () {
  return {
    waitingFor: []
  }
}

const getters = {
  isWaiting (state) {
    return state.waitingFor.length > 0
  },
  loadingText (state) {
    return state.waitingFor.length > 0 ? state.waitingFor[0].text : null
  }
}

const mutations = {
  [START]: function (state, text = '') {
    state.waitingFor.push({ text })
  },
  [END]: function (state) {
    state.waitingFor.shift()
  }
}

const actions = {
  // with loading
  [WITH_LOADING]: ({ commit, dispatch }, { action, withLoading = true }) => {
    withLoading && commit(START)
    return action
      .then(result => {
        withLoading && commit(END)
        return result
      })
      .catch(error => {
        withLoading && commit(END)
        return Promise.reject(error)
      })
  }
}

// 此module 不加namespaced，以利在root下取得
export default {
  state,
  getters,
  mutations,
  actions
}
